export default __webpack_public_path__ + "static/media/photo--sm--22.ff4efaf9.jpg";